export const REACT_APP_AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const REACT_APP_AUTH0_CLIENTID = process.env.REACT_APP_AUTH0_CLIENTID;
export const REACT_APP_AUTH0_REDIRECTURL =
  process.env.REACT_APP_AUTH0_REDIRECTURL;
export const REACT_APP_AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_BASE_URL_TAKEDOWN =
  process.env.REACT_APP_BASE_URL_TAKEDOWN;
export const REACT_APP_BASE_URL_WEBSOCKET =
  process.env.REACT_APP_BASE_URL_WEBSOCKET;
export const REACT_APP_SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const REACT_APP_GTM_ID = process.env.REACT_APP_GTM_ID;
export const REACT_APP_HUBSPOT_ID = process.env.REACT_APP_HUBSPOT_ID;
export const REACT_APP_ENABLE_AUTO_TAKEDOWN =
  process.env.REACT_APP_ENABLE_AUTO_TAKEDOWN;
export const REACT_APP_HUBSPOT_TICKET_DELAY =
  process.env.REACT_APP_HUBSPOT_TICKET_DELAY;

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
export const SUPABASE_PUBLISHABLE_KEY =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

export const REACT_APP_FEED_API_BASE_URL =
  process.env.REACT_APP_FEED_API_BASE_URL || 'https://api.bfore.ai';

export const REACT_APP_FN_TABLE =
  process.env.REACT_APP_FN_TABLE || 'fn_candidates';

export const REACT_APP_POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
export const REACT_APP_POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
